import {EmailAddressActionTypes, PhoneActionTypes} from "../actions/types";
import { EmailAddressActions } from "../actions/emailaddress.actions";
import { initialState } from "../reducers/root.reducer";
import {PhoneActions} from "../actions/phone.actions";

export const phoneReducer = (
    state: string = initialState.phone,
    action: PhoneActions
) => {
    switch (action.type) {
        case PhoneActionTypes.ADD_PHONE:
            return action.payload;
        default:
            return state;
    }
};
